/* src/app/core/pages/tfa-page/tfa-page.component.scss */
.main-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  background: whitesmoke;
}
.main-container .left-container {
  flex: 4;
  height: 100%;
}
.main-container .right-container {
  flex: 2;
  height: 100%;
  min-width: 20rem;
  max-width: 30rem;
}
/*# sourceMappingURL=tfa-page.component.css.map */
